import api from "../axios";

export async function getPatientEnrollmentKpis(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/patient-summary/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}

export async function getEnrollmentTrend(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/enrollment-trend/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}

export async function getProgramDistribution(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/program-distribution/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}
